<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'
	import Schedules from '../../schedules/layout/Schedules.vue'
	import MediaManager from './../../../MediaManager/layout/MediaManager.vue'
	import Timer from '../../timers/views/Index.vue'

	import Customers from './Customers.vue'
	import Staff from './Staff.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'schedules': Schedules,
			'multiselect': Multiselect,
			'media-manager': MediaManager,

			'customers': Customers,
			'staff': Staff,

			'timer': Timer,
		},
		data () {
			return {
				item: null,
				project: null,

				department: null,
				media: null,

				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: process.env.ROOT + '/api/' + this.$lang.getLang(),
				},

				options: [],
				isLoading: false,

				prioritylevels: null,
				statuses: null,
			}
		},
		watch: {
			'$i18n.locale'() {
				this.reload();
			}
		},
		created () {
			this.init()
		},
		methods: {
			openCreateSchedule() {

			},
			init() {
				this.getData()

				this.getPriorityLevels()
				this.getStatuses()
				this.getMedia()
			},
			getData() {
				this.$http.get('admin/projects/tasks/' + this.$route.params.id + '/edit')
				.then(response => {
					this.item = response.body

					if(this.item.projects.length) {
						this.project = this.item.projects[0]
					}

					this.$set(this.item, 'added_users', this.item.users)

					this.dropzone.url = process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/projects/tasks/' + this.item.id;

					this.formatDates()
				}).catch(function(response) {
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning"
					});
				})
			},
			lock() {
				var button = $(event.target)
				button.addClass('disabled')
				var old_locked = this.item.locked
				this.item.locked = 1
				this.$http.get('admin/projects/tasks/lock/'+this.item.id)
					.then(response => {
						button.removeClass('disabled')
						this.item.locked = response.body.locked
					}).catch(function(response) {
						console.log(response)
						button.removeClass('disabled')
						this.item.locked = old_locked
					})
			},
			unLock() {
				var button = $(event.target)
				button.addClass('disabled')
				var old_locked = this.item.locked
				this.item.locked = 0
				this.$http.get('admin/projects/tasks/unlock/'+this.item.id)
					.then(response => {
						button.removeClass('disabled')
						this.item.locked = response.body.locked
					}).catch(function(response) {
						console.log(response)
						button.removeClass('disabled')
						this.item.locked = old_locked
					})
			},
			complete() {
				this.$http.get('admin/projects/tasks/'+this.item.id+'/complete')
					.then(response => {
						this.item.completed = response.body.completed
						this.item.task_status_id = response.body.task_status_id
					}).catch(function(response) {
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					})
			},
			generateClass: function(staticClass) {
				if(this.item) {
					if(this.item.locked) {
						staticClass += ' locked'
					}
				}
				return staticClass
			},
			notification(type) {
				if(type == 'email') {
					var l = Ladda.create(document.querySelector('#btn-notification-email'))
					l.start()
					this.$http.get('admin/projects/tasks/'+this.item.id+'/notification/mail')
						.then(response => {
							if(response.body) {
								this.item.locked = response.body.locked
								this.item.trace = response.body.trace
								swal({
									title: this.$t("messages.done"),
									text: this.$t("messages.notifications_sent_correctly"),
									type: 'success',
								})
							}
							l.stop()
						}).catch(function(response) {
							console.log(response)
							l.stop()
						})
				}
			},
			getMedia() {
				this.$http.get('admin/projects/tasks/' + this.$route.params.id + '/media/media')
				.then(response => {
					this.media = response.body
				})
			},
			//-- funcion que se ejecuta con un evento desde el componente schedules/Edit.vue
			removeSchedule(schedule) {
				let index = this.schedules.indexOf(schedule)
				this.schedules.splice(index, 1)
			},
			reload() {
				this.getData()
				this.getStatuses()
				if(this.$refs.staff) {
					if(this.$refs.staff.toggle) {
						this.$refs.staff.closedTaskUser()
					}
				}
				if(this.$refs.customers) {
					if(this.$refs.customers.toggle) {
						this.$refs.customers.closedTaskCustomer()
					}
				}
			},
			reloadMedia() {
				this.getMedia()
			},
			getPriorityLevels() {
				this.$http.get('admin/projects/prioritylevels')
				.then(response => {
					this.prioritylevels = response.body
				})
			},
			getStatuses() {
				this.$http.get('admin/projects/tasks/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			formatDates() {
				if(this.item.schedules) {
					this.item.schedules.forEach(function(element) {
						var start_date = moment(element.estimated_start).format('Y-MM-DD')
						var start_time = moment(element.estimated_start).format('HH:mm')
						var end_date = moment(element.estimated_end).format('Y-MM-DD')
						var end_time = moment(element.estimated_end).format('HH:mm')

						element.start_date = start_date
						element.start_time = start_time
						element.end_date = end_date
						element.end_time = end_time
					})
				}
			},
			update() {
				if(this.item.task_status_id == 5) {
					if(this.item.auto_closing) {
						var that = this
						swal.queue([{
							title: this.$t("messages.attention"),
							text: "El auto cerrado está activado, se harán los cierres del personal y de los clientes",
							type: "warning",
							showCancelButton: true,
							confirmButtonColor: "#53e69d",
							cancelButtonColor: "#ff7676",
							confirmButtonText: "Si",
							cancelButtonText: "No",
							showLoaderOnConfirm: true,
							preConfirm: function () {
								return new Promise(function (resolve) {
									that.taskUpdate()
								})
							}
						}]).catch(response => {
							
						})
					} else {
						this.taskUpdate()
					}
				} else {
					this.taskUpdate()
				}
			},
			taskUpdate() {
				var loading = Ladda.create(document.querySelector('#btn-update'));
				loading.start();
				this.$http.put('admin/projects/tasks/' + this.$route.params.id, this.item)
				.then(response => {
					this.reload()
					loading.stop()
					swal(response.body.title, response.body.text, response.body.type)
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
			canComplete() {
				var can = true
				if(this.item.timers) {
					if(this.item.timers.length) {
						if(this.item.timers.length != this.item.users.length) {
							can = false
						}
						if(can) {
							for (var i = this.item.timers.length - 1; i >= 0; i--) {
								if(this.item.timers[i].done == 0) {
									can = false
									break
								}
							}
						}
					}
				}

				if(this.item.schedules) {
					if(this.item.schedules.length) {
						for (var i = this.item.schedules.length - 1; i >= 0; i--) {
							if(this.item.schedules[i].done == 0) {
								can = false
								break
							}
						}
					}
				}
				return can
			},
			search(query) {
				if(query) {
					this.isLoading = true
					var data = {
						query: query,
						filter: {
							department_id: null,
							team_id: null,
						}
					}

					if(this.project) {
						data.filter.team_id = this.project.team_id
					}

					if(this.department) {
						data.filter.department_id = this.department.id
					}

					this.$http.post('admin/users/search', data)
					.then(response => {
						this.isLoading = false
						this.options = response.body
					}).catch(function(response) {
						this.isLoading = false
						console.log(response)
					})
				}
			},
			changeAutoEnd() {
				this.item.auto_end = !this.item.auto_end
				this.changeSettings()
			},
			changeAutoClosing() {
				this.item.auto_closing = !this.item.auto_closing
				this.changeSettings()
			},
			changeSettings() {
				var settings = {
					auto_end: this.item.auto_end,
					auto_closing: this.item.auto_closing,
				}
				this.$http.post('admin/projects/tasks/' + this.item.id + '/settings', settings)
					.then(response => {
						this.item.auto_end = response.body.data.auto_end
						this.item.auto_closing = response.body.data.auto_closing
					}).catch(function(response) {
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					})
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/Edit.vue